import React, { useRef, useState } from 'react'
import FieldWrapper from '../FieldWrapper'
import { Select } from 'chakra-react-select'
import PropTypes from 'prop-types'

const SelectField = ({
  name,
  icon,
  validate,
  isReadOnly,
  isRequired,
  label,
  helperMessage,
  hideCheckIcon,
  noOptionsMessage,
  ...selectProps
}) => {
  const styles = {
    multiValueRemove: (base, state) => {
      return isReadOnly ? { ...base, display: 'none' } : base
    },
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
    menu: (provided) => ({ ...provided, zIndex: 9999 })
  }
  const selectRef = useRef()
  const [menuIsOpen, setMenuIsOpen] = useState()

  const openMenu = () => {
    selectRef.current.focus()
    setMenuIsOpen(true)
  }

  const onInputChange = (options, { action }) => {
    if (action === 'menu-close') {
      setMenuIsOpen(false)
    }
  }

  return (
    <FieldWrapper
      name={name}
      validate={validate}
      isReadOnly={isReadOnly}
      isRequired={isRequired}
      label={label}
      helperMessage={helperMessage}
    >
      {({ field, helpers }) => {
        return (
          <Select
            ref={selectRef}
            isSearchable={!isReadOnly}
            menuIsOpen={isReadOnly ? false : menuIsOpen}
            onFocus={openMenu}
            isClearable={!isReadOnly}
            openMenuOnClick={!isReadOnly}
            closeMenuOnSelect={!selectProps.isMulti}
            onInputChange={onInputChange}
            inputId={name}
            noOptionsMessage={(inputValue) => {
              return 'Nu exista optiuni disponibile'
            }}
            value={field?.value}
            styles={styles}
            onChange={(option) => {
              helpers.setValue(option)
            }}
            {...selectProps}
            onBlur={(e) => {
              helpers.setTouched(true)
              field.onBlur(e)
            }}
          />
        )
      }}
    </FieldWrapper>
  )
}

SelectField.propTypes = {
  name: PropTypes.string.isRequired,
  validate: PropTypes.func,
  isReadOnly: PropTypes.bool,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  helperMessage: PropTypes.string,
  noOptionsMessage: PropTypes.func
}

SelectField.defaultProps = {
  noOptionsMessage: (inputValue) => {
    return 'Nu exista optiuni disponibile'
  }
}

export default SelectField
